module.exports = __webpack_public_path__ + "static/media/3.b6890703.png";